
const CityList = [
    { "id": "1301", "name": "石家庄", },
    { "id": "1302", "name": "保定", },
    { "id": "1303", "name": "邯郸", },
    { "id": "1304", "name": "承德", },
    { "id": "1305", "name": "张家口", },
    { "id": "1306", "name": "唐山", },
    { "id": "1307", "name": "秦皇岛", },
    { "id": "1308", "name": "廊坊", },
    { "id": "1309", "name": "沧州", },
    { "id": "1310", "name": "衡水", },
    { "id": "1311", "name": "邢台", },
    { "id": "1401", "name": "太原", },
    { "id": "1402", "name": "大同", },
    { "id": "1403", "name": "晋中", },
    { "id": "1404", "name": "运城", },
    { "id": "1405", "name": "长治", },
    { "id": "1406", "name": "吕梁", },
    { "id": "1407", "name": "临汾", },
    { "id": "1408", "name": "忻州", },
    { "id": "1409", "name": "朔州", },
    { "id": "1410", "name": "晋城", },
    { "id": "1411", "name": "阳泉", },
    { "id": "1501", "name": "呼和浩特", },
    { "id": "1502", "name": "包头", },
    { "id": "1503", "name": "乌海", },
    { "id": "1504", "name": "赤峰", },
    { "id": "1505", "name": "通辽", },
    { "id": "1506", "name": "鄂尔多斯", },
    { "id": "1507", "name": "呼伦贝尔", },
    { "id": "1508", "name": "巴彦淖尔", },
    { "id": "1509", "name": "乌兰察布", },
    { "id": "1510", "name": "锡林郭勒", },
    { "id": "1511", "name": "阿拉善", },
    { "id": "1512", "name": "兴安", },
    { "id": "2101", "name": "沈阳", },
    { "id": "2102", "name": "大连", },
    { "id": "2103", "name": "鞍山", },
    { "id": "2104", "name": "抚顺", },
    { "id": "2105", "name": "抚顺", },
    { "id": "2106", "name": "丹东", },
    { "id": "2107", "name": "锦州", },
    { "id": "2108", "name": "营口", },
    { "id": "2109", "name": "阜新", },
    { "id": "2110", "name": "辽阳", },
    { "id": "2111", "name": "盘锦", },
    { "id": "2112", "name": "铁岭", },
    { "id": "2113", "name": "葫芦岛", },
    { "id": "2201", "name": "长春", },
    { "id": "2202", "name": "四平", },
    { "id": "2203", "name": "吉林", },
    { "id": "2204", "name": "辽源", },
    { "id": "2205", "name": "通化", },
    { "id": "2206", "name": "白山", },
    { "id": "2207", "name": "白城", },
    { "id": "2208", "name": "松原", },
    { "id": "2301", "name": "哈尔滨", },
    { "id": "2302", "name": "齐齐哈尔", },
    { "id": "2303", "name": "牡丹江", },
    { "id": "2304", "name": "佳木斯", },
    { "id": "2305", "name": "大庆", },
    { "id": "2306", "name": "伊春", },
    { "id": "2307", "name": "鸡西", },
    { "id": "2308", "name": "鹤岗", },
    { "id": "2309", "name": "双鸭山", },
    { "id": "2310", "name": "七台河", },
    { "id": "2311", "name": "绥化", },
    { "id": "2312", "name": "黑河", },
    { "id": "3201", "name": "苏州", },
    { "id": "3202", "name": "南京", },
    { "id": "3203", "name": "无锡", },
    { "id": "3204", "name": "常州", },
    { "id": "3205", "name": "常熟", },
    { "id": "3206", "name": "盐城", },
    { "id": "3207", "name": "淮安", },
    { "id": "3208", "name": "宿迁", },
    { "id": "3209", "name": "扬州", },
    { "id": "3210", "name": "连云港", },
    { "id": "3211", "name": "徐州", },
    { "id": "3212", "name": "镇江", },
    { "id": "3213", "name": "泰州", },
    { "id": "3214", "name": "南通", },
    { "id": "3301", "name": "杭州", },
    { "id": "3302", "name": "宁波", },
    { "id": "3303", "name": "温州", },
    { "id": "3304", "name": "金华", },
    { "id": "3305", "name": "衢州", },
    { "id": "3306", "name": "嘉兴", },
    { "id": "3307", "name": "绍兴", },
    { "id": "3308", "name": "台州", },
    { "id": "3309", "name": "丽水", },
    { "id": "3310", "name": "湖州", },
    { "id": "3311", "name": "舟山", },
    { "id": "3401", "name": "合肥", },
    { "id": "3402", "name": "芜湖", },
    { "id": "3403", "name": "蚌埠", },
    { "id": "3404", "name": "淮南", },
    { "id": "3405", "name": "马鞍山", },
    { "id": "3406", "name": "淮北", },
    { "id": "3407", "name": "铜陵", },
    { "id": "3408", "name": "安庆", },
    { "id": "3409", "name": "黄山", },
    { "id": "3410", "name": "阜阳", },
    { "id": "3411", "name": "宿州", },
    { "id": "3412", "name": "滁州", },
    { "id": "3413", "name": "六安", },
    { "id": "3414", "name": "宣城", },
    { "id": "3415", "name": "池州", },
    { "id": "3416", "name": "亳州", },
    { "id": "3501", "name": "福州", },
    { "id": "3502", "name": "厦门", },
    { "id": "3503", "name": "泉州", },
    { "id": "3504", "name": "龙岩", },
    { "id": "3505", "name": "宁德", },
    { "id": "3506", "name": "三明", },
    { "id": "3507", "name": "南平", },
    { "id": "3508", "name": "莆田", },
    { "id": "3509", "name": "漳州", },
    { "id": "3601", "name": "南昌", },
    { "id": "3602", "name": "上饶", },
    { "id": "3603", "name": "九江", },
    { "id": "3604", "name": "景德镇", },
    { "id": "3605", "name": "萍乡", },
    { "id": "3606", "name": "新余", },
    { "id": "3607", "name": "鹰潭", },
    { "id": "3608", "name": "赣州", },
    { "id": "3609", "name": "宜春", },
    { "id": "3610", "name": "吉安", },
    { "id": "3611", "name": "抚州", },
    { "id": "3701", "name": "济南", },
    { "id": "3702", "name": "青岛", },
    { "id": "3703", "name": "淄博", },
    { "id": "3704", "name": "烟台", },
    { "id": "3705", "name": "枣庄", },
    { "id": "3706", "name": "东营", },
    { "id": "3707", "name": "潍坊", },
    { "id": "3708", "name": "济宁", },
    { "id": "3709", "name": "泰安", },
    { "id": "3710", "name": "威海", },
    { "id": "3711", "name": "日照", },
    { "id": "3712", "name": "莱芜", },
    { "id": "3713", "name": "临沂", },
    { "id": "3714", "name": "德州", },
    { "id": "3715", "name": "聊城", },
    { "id": "3716", "name": "滨州", },
    { "id": "3717", "name": "菏泽", },
    { "id": "4101", "name": "郑州", },
    { "id": "4102", "name": "新乡", },
    { "id": "4103", "name": "洛阳", },
    { "id": "4104", "name": "安阳", },
    { "id": "4105", "name": "焦作", },
    { "id": "4106", "name": "许昌", },
    { "id": "4107", "name": "平顶山", },
    { "id": "4108", "name": "漯河", },
    { "id": "4109", "name": "开封", },
    { "id": "4110", "name": "濮阳", },
    { "id": "4111", "name": "鹤壁", },
    { "id": "4112", "name": "南阳", },
    { "id": "4113", "name": "三门峡", },
    { "id": "4114", "name": "驻马店", },
    { "id": "4115", "name": "商丘", },
    { "id": "4116", "name": "信阳", },
    { "id": "4117", "name": "周口", },
    { "id": "4201", "name": "武汉", },
    { "id": "4202", "name": "十堰", },
    { "id": "4203", "name": "襄樊", },
    { "id": "4204", "name": "随州", },
    { "id": "4205", "name": "荆门", },
    { "id": "4206", "name": "孝感", },
    { "id": "4207", "name": "宜昌", },
    { "id": "4208", "name": "黄冈", },
    { "id": "4209", "name": "鄂州", },
    { "id": "4210", "name": "荆州", },
    { "id": "4211", "name": "黄石", },
    { "id": "4212", "name": "咸宁", },
    { "id": "4301", "name": "长沙", },
    { "id": "4302", "name": "株洲", },
    { "id": "4303", "name": "湘潭", },
    { "id": "4304", "name": "衡阳", },
    { "id": "4305", "name": "邵阳", },
    { "id": "4306", "name": "岳阳", },
    { "id": "4307", "name": "张家界", },
    { "id": "4308", "name": "益阳", },
    { "id": "4309", "name": "常德", },
    { "id": "4310", "name": "娄底", },
    { "id": "4311", "name": "郴州", },
    { "id": "4312", "name": "永州", },
    { "id": "4313", "name": "怀化", },
    { "id": "4401", "name": "广州", },
    { "id": "4402", "name": "深圳", },
    { "id": "4403", "name": "东莞", },
    { "id": "4404", "name": "佛山", },
    { "id": "4405", "name": "珠海", },
    { "id": "4406", "name": "汕头", },
    { "id": "4407", "name": "韶关", },
    { "id": "4408", "name": "湛江", },
    { "id": "4409", "name": "肇庆", },
    { "id": "4410", "name": "江门", },
    { "id": "4411", "name": "茂名", },
    { "id": "4412", "name": "惠州", },
    { "id": "4413", "name": "梅州", },
    { "id": "4414", "name": "汕尾", },
    { "id": "4415", "name": "河源", },
    { "id": "4416", "name": "阳江", },
    { "id": "4417", "name": "清远", },
    { "id": "4418", "name": "中山", },
    { "id": "4419", "name": "潮州", },
    { "id": "4420", "name": "揭阳", },
    { "id": "4421", "name": "云浮", },
    { "id": "4501", "name": "南宁", },
    { "id": "4502", "name": "柳州", },
    { "id": "4503", "name": "桂林", },
    { "id": "4504", "name": "梧州", },
    { "id": "4505", "name": "北海", },
    { "id": "4506", "name": "崇左", },
    { "id": "4507", "name": "来宾", },
    { "id": "4508", "name": "贺州", },
    { "id": "4509", "name": "百色", },
    { "id": "4510", "name": "玉林", },
    { "id": "5101", "name": "成都", },
    { "id": "5102", "name": "自贡", },
    { "id": "5103", "name": "攀枝花", },
    { "id": "5104", "name": "泸州", },
    { "id": "5105", "name": "德阳", },
    { "id": "5106", "name": "绵竹", },
    { "id": "5107", "name": "绵阳", },
    { "id": "5108", "name": "广元", },
    { "id": "5109", "name": "遂宁", },
    { "id": "5110", "name": "内江", },
    { "id": "5111", "name": "乐山", },
    { "id": "5112", "name": "南充", },
    { "id": "5113", "name": "眉山", },
    { "id": "5114", "name": "宜宾", },
    { "id": "5115", "name": "广安", },
    { "id": "5116", "name": "达州", },
    { "id": "5117", "name": "雅安", },
    { "id": "5118", "name": "巴中", },
    { "id": "5119", "name": "资阳", },
    { "id": "5201", "name": "贵阳", },
    { "id": "5202", "name": "六盘水", },
    { "id": "5203", "name": "遵义", },
    { "id": "5204", "name": "铜仁", },
    { "id": "5205", "name": "毕节", },
    { "id": "5206", "name": "安顺", },
    { "id": "5301", "name": "昆明", },
    { "id": "5302", "name": "昭通", },
    { "id": "5303", "name": "曲靖", },
    { "id": "5304", "name": "玉溪", },
    { "id": "5305", "name": "保山", },
    { "id": "5306", "name": "普洱", },
    { "id": "5307", "name": "丽江", },
    { "id": "5308", "name": "临沧", },
    { "id": "6101", "name": "西安", },
    { "id": "6102", "name": "宝鸡", },
    { "id": "6103", "name": "咸阳", },
    { "id": "6104", "name": "渭南", },
    { "id": "6105", "name": "铜川", },
    { "id": "6106", "name": "延安", },
    { "id": "6107", "name": "榆林", },
    { "id": "6108", "name": "汉中", },
    { "id": "6109", "name": "安康", },
    { "id": "6110", "name": "商洛", },
    { "id": "6201", "name": "兰州", },
    { "id": "6202", "name": "嘉峪关", },
    { "id": "6203", "name": "金昌", },
    { "id": "6204", "name": "天水", },
    { "id": "6205", "name": "酒泉", },
    { "id": "6401", "name": "银川", },
    { "id": "6402", "name": "石嘴山", },
    { "id": "6403", "name": "吴忠", },
    { "id": "6404", "name": "固原", },
    { "id": "6405", "name": "中卫", },
    { "id": "6802", "name": "自贡", },
    { "id": "6803", "name": "北京", },
    { "id": "6804", "name": "上海", },
    { "id": "6805", "name": "天津", },
    { "id": "6806", "name": "重庆", },
    { "id": "6807", "name": "楚雄州", },
    { "id": "6808", "name": "德宏", },
    { "id": "6809", "name": "西双版纳", },
    { "id": "6810", "name": "大理州", },
    { "id": "6811", "name": "红河", }
]


const CityHotList = [
    { "id": "0", "name": "全国", },
    { "id": "6803", "name": "北京", },
    { "id": "6804", "name": "上海", },
    { "id": "4401", "name": "广州", },
    { "id": "4402", "name": "深圳", },
    { "id": "3301", "name": "杭州", },
    { "id": "6805", "name": "天津", },
    { "id": "6101", "name": "西安", },
    { "id": "3201", "name": "苏州", },
    { "id": "4201", "name": "武汉", },
    { "id": "3502", "name": "厦门", },
    { "id": "4301", "name": "长沙", },
    { "id": "5101", "name": "成都", },
    { "id": "4101", "name": "郑州", },
    { "id": "6806", "name": "重庆", },

]
export {
    CityList,
    CityHotList
}



